import { createAction, props } from '@ngrx/store';
import { NewsCategory } from '../../models';

export const LoadCategories = createAction('[Content] Load News Categories');
export const LoadCategoriesSuccess = createAction('[Content] Load News Categories Success', props<{ categories: NewsCategory[] }>());
export const LoadCategoriesFail = createAction('[Content] Load News Categories Fail', props<{ error: any }>());
